import styled from "styled-components";
import PageHeader from "../../features/shared/PageHeader";

const ListItem = styled.li`
  display: list-item;
  list-style-type: disc;
  margin-left: 24px;
  &::marker {
    color: #1b6dc1;
  }
`;

export default function PrivacyPolicy() {
  const sections = [
    { id: "intro", title: "Introduction" },
    { id: "collect", title: "Information We Collect" },
    { id: "usage", title: "Usage Data" },
    { id: "cookies", title: "Tracking & Cookies Data" },
    { id: "how-use", title: "How We Use Your Information" },
    { id: "sharing", title: "Sharing of Information" },
    { id: "protect", title: "How We Protect Your Information" },
    { id: "rights", title: "User Rights" },
    { id: "retention", title: "Data Retention" },
    { id: "children", title: "Children's Privacy" },
    { id: "changes", title: "Changes to This Privacy Policy" },
    { id: "contact", title: "Contact Us" },
    { id: "law", title: "Governing Law" },
  ];

  return (
    <div className="container page-navbar-space">
      <PageHeader>Privacy Policy</PageHeader>
      <div className="row mt-5">
        {/* LEFT SIDE: MAIN CONTENT */}
        <div
          className="col-lg-8 col-xl-9"
          style={{ color: "#444", lineHeight: "1.7" }}
        >
          <p className="mb-4 size-16 fw-normal">
            <strong>Effective from: January 1, 2025</strong>
          </p>

          <p className="mb-4 size-16 fw-normal">
            ChefEats, Inc. ("we," "us," or "our") operates the OwnFood website
            at{" "}
            <a href="https://www.ownfood.com" className="text-decoration-none">
              https://www.ownfood.com
            </a>
            , and the OwnFood app and services.
          </p>

          <p className="mb-4 size-16 fw-normal">
            This page informs you of our policies regarding the collection, use,
            and disclosure of personal data when you use our Service and the
            choices you have associated with that data.
          </p>

          <p className="mb-5 border-bottom pb-4 size-16 fw-normal">
            We use your data to provide and improve the Service. By using the
            Service, you agree to the collection and use of information in
            accordance with this policy.
          </p>

          <section
            id="intro"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">1. Introduction</h4>
            <p className="size-16 fw-normal">
              OwnFood is a food marketplace for Food Lovers. Our vision and
              mission is to provide home-cooked healthy food and to connect
              individuals who represent and sell homemade food to potential
              customers who are looking for delicious and authentic healthy
              homemade meals.
            </p>
          </section>

          <section
            id="collect"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">2. Information We Collect:</h4>
            <p className="size-16 fw-normal">
              <strong>Personal Data:</strong> Name, Phone Number, Email address,
              House addresses, payment details, etc.
            </p>
            <p className="size-16 fw-normal">
              <strong>Non-Personal Data:</strong> Browser information, location,
              duration time, etc.
            </p>
            <p className="size-16 fw-normal">
              <strong>Data from Third Parties:</strong> Information received
              from social media logins, third-party partners.
            </p>
          </section>

          <section
            id="usage"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">3. Usage Data</h4>
            <p className="size-16 fw-normal">
              We may also collect information on how the Service is accessed and
              used ("Usage Data"). This may include IP addresses, browser type,
              and pages visited.
            </p>
          </section>

          <section
            id="cookies"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">4. Tracking & Cookies Data</h4>
            <p className="size-16 fw-normal">
              We use cookies and similar tracking technologies to track the
              activity on our Service and hold certain information.
            </p>
            <ul className="ps-2 size-16">
              <ListItem>
                <strong>Session Cookies:</strong> To operate our Service.
              </ListItem>
              <ListItem>
                <strong>Preference Cookies:</strong> To remember your settings.
              </ListItem>
            </ul>
          </section>

          <section
            id="how-use"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">5. How We Use Your Information</h4>
            <ul className="size-16 fw-normal">
              <ListItem>
                To provide and maintain the delivery and communication.
              </ListItem>
              <ListItem>For payment processing.</ListItem>
              <ListItem>
                To improve platform usability and personalization.
              </ListItem>
            </ul>
          </section>

          <section
            id="sharing"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">6. Sharing of Information</h4>
            <ul className="size-16 fw-normal">
              <ListItem>With food sellers to fulfill orders.</ListItem>
              <ListItem>With delivery riders for order delivery.</ListItem>
              <ListItem>Legal disclosure if required by law.</ListItem>
            </ul>
          </section>

          <section
            id="protect"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">7. How We Protect Your Information</h4>
            <ul className="size-16 fw-normal">
              <ListItem>Encryption of sensitive data.</ListItem>
              <ListItem>Secure storage mechanisms.</ListItem>
            </ul>
          </section>

          <section
            id="rights"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">8. User Rights</h4>
            <ul className="size-16 fw-normal">
              <ListItem>
                Right to access, rectify, or delete personal data.
              </ListItem>
              <ListItem>Right to withdraw consent.</ListItem>
            </ul>
          </section>

          <section
            id="retention"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">9. Data Retention</h4>
            <p className="size-16 fw-normal">
              How long we store user data (e.g., as long as the Rider/Seller
              provides services).
            </p>
          </section>

          <section
            id="children"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">10. Children's Privacy</h4>
            <p className="size-16 fw-normal">
              We do not knowingly collect personally identifiable information
              from anyone under the age of 18.
            </p>
          </section>

          <section
            id="changes"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">11. Changes to This Privacy Policy</h4>
            <p className="size-16 fw-normal">
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page.
            </p>
          </section>

          <section
            id="contact"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">12. Contact Us</h4>
            <p className="mb-0 size-16 fw-normal">
              Email:{" "}
              <a
                href="mailto:support@ownfood.com"
                className="text-decoration-none"
              >
                support@ownfood.com
              </a>
            </p>
            <p className="size-16 fw-normal">Phone: +1 (202) 555 - 0187</p>
          </section>

          <section
            id="law"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">13. Governing Law</h4>
            <p className="size-16 fw-normal">
              This Privacy Policy is governed by the laws of the State of
              Michigan, USA.
            </p>
          </section>
        </div>

        {/* RIGHT SIDE: TABLE OF CONTENTS (STAY STICKY) */}
        <div className="col-lg-4 col-xl-3 d-none d-lg-block">
          <div className="sticky-top z-0" style={{ top: "9rem", zIndex: 1 }}>
            <h5 className="fw-bold mb-3 mt-1">Table of Contents</h5>
            <div className="border-start border-2">
              {sections.map((section, index) => (
                <a
                  key={section.id}
                  href={`#${section.id}`}
                  className="d-block py-2 px-3 text-decoration-none text-muted border-bottom"
                  style={{ fontSize: "1rem", transition: "0.2s" }}
                  onMouseOver={(e) => (e.target.style.color = "#007bff")}
                  onMouseOut={(e) => (e.target.style.color = "#6c757d")}
                >
                  {index + 1}. {section.title}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
